import React, { type FunctionComponent, useState } from 'react'
import { type RadiumStyles, SVGIcon } from 'ic-snacks'
import { Button } from '@retailer-platform/shared-components'
import { StopIcon } from '@instacart/ids-core'
import { useEditProducts } from 'domains/products/components/search/utils/useEditProducts.hooks'
import { useSelectionManager } from 'utils/selection-manager/SelectionManager'
import { EditProductsModal } from 'domains/products/components/edit-products-modal/EditProductsModal'
import { useRetailerId, usePartnerId } from 'utils/routing/params.hooks'
import { type ProductSearchParams } from 'domains/products/components/search/utils/types'
import useGetRetailerProductsVariables from 'domains/products/api/useGetRetailerProductsVariables.hooks'
import { useGetRetailerProductsForCptQuery } from 'domains/products/api'
import { useDeepMemo } from 'utils/react/react.hooks'
import { EditInAssortmentModal } from 'domains/products/components/edit-in-assortment-modal/EditInAssortmentModal'

const editInAssortmentButtonCss: RadiumStyles = {
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'center',
  alignItems: 'center',
  margin: 'auto auto auto 10px',
  height: 40,
}

interface ProductsSearchBulkEditInAssortmentButtonProps {
  searchParams: ProductSearchParams
}

export const ProductsSearchBulkEditInAssortmentButton: FunctionComponent<
  ProductsSearchBulkEditInAssortmentButtonProps
> = ({ searchParams }) => {
  const retailerId = useRetailerId()
  const [showModal, setShowModal] = useState(false)
  const { selectedCount, selectedKeys } = useSelectionManager()
  const rpVariables = useGetRetailerProductsVariables(searchParams)

  const {
    data: rpData,
    loading: rpLoading,
    error: rpError,
  } = useGetRetailerProductsForCptQuery({
    variables: rpVariables.result,
  })

  const entityIds = useDeepMemo(() => {
    if (selectedKeys?.length) {
      return selectedKeys
    }
    if (!rpData?.retailerToolsServiceGetRetailerProducts?.results) {
      return []
    }
    return rpData.retailerToolsServiceGetRetailerProducts.results.map(p => p.productId)
  }, [selectedKeys, rpData?.retailerToolsServiceGetRetailerProducts?.results, searchParams.locale])

  return (
    <React.Fragment>
      <Button
        style={editInAssortmentButtonCss}
        variant={'secondary'}
        onClick={() => setShowModal(true)}
      >
        {selectedCount}
        <StopIcon size={15} color="systemGrayscale70" css={{ marginRight: '5px' }} />
      </Button>

      {showModal && (
        <EditInAssortmentModal
          retailerId={retailerId}
          productIds={entityIds}
          onClose={() => setShowModal(false)}
        />
      )}
    </React.Fragment>
  )
}
